(function () {
    "use strict";

    cip_StatusController.cleanAndRefresh = function (callback) {
        $('#body').empty();
        $('#body').append(cip_StatusWidget.createDefaultScreen());

        var parameters = cc_Util.getUrlVars();

        cip_Common.applicantAccessKey = parameters.s;

        if (cip_Common.applicantAccessKey) {
            cip_StatusServer.getApplicationSummaries(cip_Common.applicantAccessKey, function (response) {
                cip_StatusController.processApplicationSummariesResponse(response);

                if (callback) {
                    callback();
                }
            });
        }
    };

    cip_StatusController.processApplicationSummariesResponse = function (summariesResponse) {
        cip_StatusUI.attachApplicationSummaries(summariesResponse);
    };

    cip_StatusController.processSelectedApplicationDetailResponse = function (detailResponse) {
        cip_StatusUI.attachApplicationDetail(detailResponse);
    };
})();